<template>
  <div>
    <CalendarMeeting :viewOnly="true" />
  </div>
</template>

<script setup>
import CalendarMeeting from "@/components/CalendarMeeting.vue";
</script>

<style></style>
